//
// Copyright 2022 DXOS.org
//
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_dxos_halo_credentials } from "../../halo/credentials_pb.js";
import { file_dxos_keys } from "../../keys_pb.js";
/**
 * Describes the file dxos/mesh/teleport/admission-discovery.proto.
 */
export const file_dxos_mesh_teleport_admission_discovery = /*@__PURE__*/ fileDesc("CixkeG9zL21lc2gvdGVsZXBvcnQvYWRtaXNzaW9uLWRpc2NvdmVyeS5wcm90bxISZHhvcy5tZXNoLnRlbGVwb3J0InIKHUdldEFkbWlzc2lvbkNyZWRlbnRpYWxSZXF1ZXN0EicKCXNwYWNlX2tleRgBIAEoCzIULmR4b3Mua2V5cy5QdWJsaWNLZXkSKAoKbWVtYmVyX2tleRgCIAEoCzIULmR4b3Mua2V5cy5QdWJsaWNLZXkiYQoeR2V0QWRtaXNzaW9uQ3JlZGVudGlhbFJlc3BvbnNlEj8KFGFkbWlzc2lvbl9jcmVkZW50aWFsGAEgASgLMiEuZHhvcy5oYWxvLmNyZWRlbnRpYWxzLkNyZWRlbnRpYWwynAEKGUFkbWlzc2lvbkRpc2NvdmVyeVNlcnZpY2USfwoWR2V0QWRtaXNzaW9uQ3JlZGVudGlhbBIxLmR4b3MubWVzaC50ZWxlcG9ydC5HZXRBZG1pc3Npb25DcmVkZW50aWFsUmVxdWVzdBoyLmR4b3MubWVzaC50ZWxlcG9ydC5HZXRBZG1pc3Npb25DcmVkZW50aWFsUmVzcG9uc2ViBnByb3RvMw", [file_dxos_halo_credentials, file_dxos_keys]);
/**
 * Describes the message dxos.mesh.teleport.GetAdmissionCredentialRequest.
 * Use `create(GetAdmissionCredentialRequestSchema)` to create a new message.
 */
export const GetAdmissionCredentialRequestSchema = /*@__PURE__*/ messageDesc(file_dxos_mesh_teleport_admission_discovery, 0);
/**
 * Describes the message dxos.mesh.teleport.GetAdmissionCredentialResponse.
 * Use `create(GetAdmissionCredentialResponseSchema)` to create a new message.
 */
export const GetAdmissionCredentialResponseSchema = /*@__PURE__*/ messageDesc(file_dxos_mesh_teleport_admission_discovery, 1);
/**
 * @generated from service dxos.mesh.teleport.AdmissionDiscoveryService
 */
export const AdmissionDiscoveryService = /*@__PURE__*/ serviceDesc(file_dxos_mesh_teleport_admission_discovery, 0);
//# sourceMappingURL=admission-discovery_pb.js.map